import { Component, ViewChild } from '@angular/core';
import { ModalComponent } from '@shared/components/modal/modal.component';

@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
	@ViewChild('hamburgerModal') private hamburgerModal: ModalComponent;
	public isMobileDevice = false;
	
	constructor() {
		this.isMobileDevice = this.isMobile();
	}

	public openHamburgerMenu(): void {
		this.hamburgerModal.open();
	}

	private isMobile(): boolean {
		return window.innerWidth < 768;
	}
}
